module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_c('span', {
    staticClass: "th11"
  }, [_vm._v("Prólogo")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('img', {
    attrs: {
      "alt": "img2.png",
      "src": "images/img2.png"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("PRÓDIGO: BLOG OFICIAL DE LOS HIJOS PRÓDIGOS")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Fecha: Viernes, 18 de febrero de 2011")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Autor: Jake")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Anuncio de servicio a la comunidad (bueno, no realmente)—DL; NL")]), _c('a', {
    attrs: {
      "id": "a0"
    }
  }), _c('span', {
    attrs: {
      "href": "#/notes#a52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("{1}")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("Hola, chicos. Nos han llegado un montón de peticiones en el último par de días, semanas, lo que sea, y todas han sido del mismo tipo. Todos quieren saber la historia de cómo pasamos de la negación a la demostración pública de afecto, que fue transmitida a millones de personas. De hecho, yo mismo me incluyo entre ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("La verdad es que yo fui la última persona en enterarse de que estaba enamorado de Parker McAvoy. Bueno, no, eso no es estrictamente cierto. En realidad, creo que Parker fue el último en enterarse. Pero no pude ocultárselo por mucho tiempo. ¡Aparentemente, ni siquiera pude ocultárselo al resto del mundo, aun cuando no lo sabía ni yo mismo! Según la esposa de Chris, hasta la gente que vive en China supo que estaba enamorado de Parker antes de que yo lo hiciera, lo cual es bastante patético. Diablos, "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Jimmy ")]), _vm._v("lo supo antes que yo. Créanme, eso es bastante humillante. Por otra parte, todos pueden darse cuenta que Jimmy es mucho más inteligente de lo que parece.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("De todos modos, como lo siguiente se los ilustrará, fui bastante tonto por un amplio período de tiempo, pero finalmente me di cuenta. Sé lo que están pensando, pero les prometo que esto no tiene nada que ver con las ideas que todos ustedes trataron de meterme en la cabeza durante años. No están ni siquiera cerca de quien primero hizo esa suposición. No, la primera persona en asumir que Parker era mi novio, fue mi mamá, y Parker todavía ni siquiera sabía que yo era gay. Hablando de torpeza...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1afeef34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0